<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams"  [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"


>
    <ng-container topToolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>


  <ng-container gridColumnDef="Name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Name.displayControl.styles.style"
          [ngClass]="row.cells.Name.displayControl.styles.classes"
          [matTooltip]="row.cells.Name.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="Status_Name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.Status_Name.displayControl.styles.style"
          [ngClass]="row.cells.Status_Name.displayControl.styles.classes"
          [matTooltip]="row.cells.Status_Name.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.Status_Name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="IsManufacturingStagingLocation">

    <ng-template gridCellDisplayControlDef let-row>
    <mat-checkbox data-cy="checkBox" [formControl]="row.formGroup.controls['IsManufacturingStagingLocation_display']"
                  class="datex-checkbox"
                  color="primary"
                  [ngStyle]="row.cells.IsManufacturingStagingLocation.displayControl.styles.style"
                  [ngClass]="row.cells.IsManufacturingStagingLocation.displayControl.styles.classes"
                  [matTooltip]="row.cells.IsManufacturingStagingLocation.displayControl.tooltip"
                  matTooltipClass="datex-control-tooltip">{{row.cells.IsManufacturingStagingLocation.displayControl.label}}</mat-checkbox>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <mat-checkbox data-cy="checkBox" [formControl]="row.formGroup.controls['IsManufacturingStagingLocation_edit']"
                  class="datex-checkbox"
                  color="primary"
                  [ngStyle]="row.cells.IsManufacturingStagingLocation.editControl.styles.style"
                  [ngClass]="row.cells.IsManufacturingStagingLocation.editControl.styles.classes"
                  [matTooltip]="row.cells.IsManufacturingStagingLocation.editControl.tooltip"
                  matTooltipClass="datex-control-tooltip">{{row.cells.IsManufacturingStagingLocation.editControl.label}}</mat-checkbox>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="ManufacturingLineFlag">

    <ng-template gridCellDisplayControlDef let-row>
    <mat-checkbox data-cy="checkBox" [formControl]="row.formGroup.controls['ManufacturingLineFlag_display']"
                  class="datex-checkbox"
                  color="primary"
                  [ngStyle]="row.cells.ManufacturingLineFlag.displayControl.styles.style"
                  [ngClass]="row.cells.ManufacturingLineFlag.displayControl.styles.classes"
                  [matTooltip]="row.cells.ManufacturingLineFlag.displayControl.tooltip"
                  matTooltipClass="datex-control-tooltip">{{row.cells.ManufacturingLineFlag.displayControl.label}}</mat-checkbox>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <mat-checkbox data-cy="checkBox" [formControl]="row.formGroup.controls['ManufacturingLineFlag_edit']"
                  class="datex-checkbox"
                  color="primary"
                  [ngStyle]="row.cells.ManufacturingLineFlag.editControl.styles.style"
                  [ngClass]="row.cells.ManufacturingLineFlag.editControl.styles.classes"
                  [matTooltip]="row.cells.ManufacturingLineFlag.editControl.tooltip"
                  matTooltipClass="datex-control-tooltip">{{row.cells.ManufacturingLineFlag.editControl.label}}</mat-checkbox>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
